<script>
import { fandomBasicMixin, fandomExtendedMixin } from "src/modules/fandom_mixins_module.js";
import { get, omit } from "lodash";

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin],
  data: function() {
    return {
      globalState: globalState
    };
  },
  methods: {
    omit,
    getContentResponsiveImage(name) {
      const content = this.content;
      if ((globalState.viewport["sm"] || globalState.viewport["xs"]) && this.exists(content[`${name}_mobile`])) {
        return this.expandUrl(content[`${name}_mobile`].url);
      } else if (this.exists(content[name])) {
        return this.expandUrl(content[name].url);
      }
      return null;
    },
    getContentResponsiveImageURL(name) {
      const imageUrl = this.getContentResponsiveImage(name);
      return this.exists(imageUrl) ? `url("${imageUrl}")` : null;
    },
    toggleVideoPopup() {
      if(this.isVideoPresent) {
        if (this.checkRegistration(this.content.play)) {
          Vue.set(globalState, "videoPopupContent", { content: this.content, containerContent: this.containerContent });
        } else {
          $("#modal-registration").modal("show");
        }
      }
    },
    getBackgroundUrl: Fandom.getBackgroundUrl,
  },
  computed: {
    propagateBackground() {
      return get(this, ["content", "propagate_background"], false);
    },
    containerStyles() {
      return {
        "background-image": this.propagateBackground ? this.getContentResponsiveImageURL("background_image") : ""
      };
    },
    containerClasses() {
      return this.propagateBackground ? "themed-item bg-cover-center" : "";
    },
    textColumnWidth() {
      const size = get(this, ["content", "text_column_width"], 6);
      return parseInt(size);
    },
    isVideoPresent() {
      return !!this.content.play;
    },
    hasAspectRatio() {
      return Fandom.exists(this.content.height) && this.content.height.indexOf("$") === 0;
    },
    height() {
      return get(this, ["content", "height"], "$4by3");
    },
    aspectRatioClasses() {
      if (this.hasVideo) {
        return this.height.indexOf("$") === 0 ? this.height.replace("$", "embed-responsive embed-responsive-") : "h-100 ar-sm-1by1";
      } else {
        return this.height.indexOf("$") === 0 ? this.height.replace("$", "ar-") : "h-100 ar-sm-1by1";
      }
    },
    contentClasses() {
      const classes = [];

      // Mobile reverse management. Default image and text
      if ((globalState.viewport.sm || globalState.viewport.xs) && this.content.reverse_mobile) {
        classes.push("flex-column-reverse");
      } else if (this.content.reverse) {
        classes.push("flex-row-reverse");
      }
      
      return classes;
    },
    contentStyle() {
      return {
        "min-height": this.content.height ? this.content.height : "600px"
      };
    },
    contentStyle() {
      const height = this.height.indexOf("$") !== 0 ? this.height : null;
      return {
        "min-height": (globalState.viewport.xs || globalState.viewport.sm) ? "auto" : height
      };
    },
    mediaColumnClasses() {
      const classes = [`col-lg-${12 - this.textColumnWidth}`];

      // d-md-block preserve image column from md breakpoint.
      if (!Fandom.exists(this.content.image) && !Fandom.exists(this.content.video)) {
        classes.push("d-none d-lg-block")
      }
      if (this.content.play) {
        classes.push("cursor-pointer");
      }
      return classes;
    },
    verticalAlign() {
      const discoverMore = this.content.discover_more;
      if (discoverMore) {
        return "h-100";
      } else {
        let align = "";
        switch (get(this, ["content", "vertical_align"], 'center')) {
          case 'bottom':
            align = 'end';
            break;
          case 'top':
            align = 'start';
            break;
          case 'center':
          default:
            align = 'center';
            break;
        }

        return `align-items-${align}`;
      }
    },
    stripeClasses() {
      const classes = [];
      const paddingY = get(this.content, ["padding_y"], this.content.boxed ? 4 : 0);
      const paddingTop = get(this.content, ["padding_top"], paddingY);
      const paddingBottom = get(this.content, ["padding_bottom"], paddingY);

      if (paddingTop) classes.push(`mt-${paddingTop}`);
      if (paddingBottom) classes.push(`mb-${paddingBottom}`);
      if (!this.propagateBackground) classes.push('themed-item');

      // The boxed method sets default margins and rounds the edges
      if (this.content.boxed) classes.push("border-radius");
      
      return classes;
    },
    textColumnClasses() {
      const verticalAlign = get(this.content, "vertical_align", "center");
      return [`col-lg-${this.textColumnWidth}`, `justify-content-${verticalAlign}`];
    },
    textColumnInsetClasses() {
      const classes = [this.content.text_column_inset_classes || "col-md-10 col-12"];
      if (this.content.discover_more) {
        classes.push("d-flex flex-column justify-content-between")
      }
      return classes;
    }
  },
};
</script>

<template>
  <div v-easyadmin="easyadminId" class="px-3 px-md-0" v-if="isContentVisibleToUser()" :style="[theme, containerStyles]" :class="[contentType, containerClasses]" two-col-component>
    <component :is="content.url ? 'a' : 'div'" :href="content.url ? content.url.url : null" :target="content.url ? getTarget(content.url) : null">
      <div class="container position-relative" :class="[stripeClasses, {'bg-vodafone': content.theme == 'dark' && !content.background_color && !content.background_image, 'bg-white': content.boxed}]">
        <span v-if="content.stripe_id" class="anchor" :id="content.stripe_id"></span>
        <div v-if="content.background_image && !propagateBackground"
              :style="{'background-image': getContentResponsiveImageURL('background_image')}"
              class="w-100 h-100 position-absolute-center bg-cover-center">
        </div>
        <div class="row" :class="contentClasses" :style="contentStyle">
          <div class="col-12 media-column d-inline-flex px-0 px-sm-3 px-md-0 align-items-top" :class="mediaColumnClasses" @click="toggleVideoPopup()">
            <div
              class="bg-cover-center w-100 position-relative"
              v-if="content.image"
              :title="content.image.alt"
              :style="{'background-image': getContentResponsiveImageURL('image')}"
              :class="aspectRatioClasses"
            >
            </div>
            <span class="position-absolute-center d-flex flex-column justify-content-center align-items-center text-white" v-if="isVideoPresent">
              <div class="play-icon-container">
                <i class="fal fa-2x fa-play ml-1"></i>
              </div>
            </span>
          </div>
          <div class="col-12 d-flex flex-column p-4 text-column" :class="textColumnClasses">
            <div class="row justify-content-center" :class="verticalAlign">
              <div :class="textColumnInsetClasses">
                <text-section
                  :content="content"
                  :playButton="isVideoPresent"
                  @openvideo="toggleVideoPopup()"
                  :opt-container-content="containerContent"
                ></text-section>
                <div v-if="content.discover_more"><i class="far fa-chevron-right mr-2"></i>{{ft("globals.discover_more")}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </component>
  </div>
</template>

<style lang="scss">
[two-col-component] {
  .border-radius {
    border-radius: .5rem;
    overflow: hidden;
  }

  @include media-breakpoint-down(md) {

    .mh-100vh {
      min-height: auto !important;
    }

    .ar-sm-16by9 {
      padding-bottom: 56.25%;
    }
  }

  [text-section-component] {
    h2 {
      font-weight: 400;
    }
  }

}
</style>
